import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Section, Heading } from '../s'
import Paragraph from 'components/typography/paragraph'

const TripletexValueMapping = () => (
    <>
        <Section>
            <Heading>
                <FormattedMessage
                    id="integration_tripletex_heading_department_handling"
                    defaultMessage="Department handling" />
            </Heading>
            <Paragraph className="compact">
                <FormattedMessage
                    id="integration_tripletex_department_handling"
                    defaultMessage="If you’re using the department feature in your Tripletex account, new users will be added to the first department in the list. You can manage which departments users belong to in Tripletex." />
            </Paragraph>
        </Section>
        <Section>
            <Heading>
                <FormattedMessage
                    id="integration_tripletex_heading_division_handling"
                    defaultMessage="Division handling" />
            </Heading>
            <Paragraph className="compact">
                <FormattedMessage
                    id="integration_tripletex_division_handling"
                    defaultMessage="If you’re using the division feature in your Tripletex account, new users will be added to the first division in the list. You can manage which divisions users belong to in Tripletex." />
            </Paragraph>
        </Section>
    </>
)

export default TripletexValueMapping